import * as _React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AIAgentTemplatesList } from './AIAgentTemplatesList';
import { AIAgentTemplateDetail } from './AIAgentTemplateDetail';

export function AIAgentTemplates() {
	return (
		<Switch>
			<Route exact path='/ai-agent-templates' component={AIAgentTemplatesList} />
			<Route exact path='/ai-agent-templates/new' component={AIAgentTemplateDetail} />
			<Route exact path='/ai-agent-templates/:id' component={AIAgentTemplateDetail} />
		</Switch>
	);
}
